module.exports = __webpack_public_path__ + "img/14.a7de03d8.png";